export const initDisclaimer = () => {
  const mainContent = $('#main-content');
  const disclaimer = $('#disclaimer');
  let disclaimerId = '';
  let cookieName = '';

  if (disclaimer.length) {
    disclaimerId = disclaimer.data('id');
    cookieName = `${disclaimerId}-ACCEPTED`;
  }

  const showDisclaimer = () => {
    mainContent.children().hide();
    disclaimer.removeClass('d-none');
    mainContent.append(disclaimer);

    addEvtListeners();
  };

  const closeDisclaimer = () => {
    setCookie(cookieName, 'true', 86400000);
    mainContent.children().show();
    disclaimer.hide();
    $(window).scrollTop(0);
  };

  const addEvtListeners = () => {
    const btnAcceptDisclaimer = $('#close-disclaimer');
    let checkboxAChecked = false;
    let checkboxBChecked = false;

    const checkCanSubmit = () => {
      if (checkboxAChecked && checkboxBChecked) {
        btnAcceptDisclaimer.prop('disabled', false);
      } else {
        btnAcceptDisclaimer.prop('disabled', true);
      }
    };

    $('#check-a').on('change', (e: JQuery.ChangeEvent) => {
      checkboxAChecked = e.target.checked;

      checkCanSubmit();
    });

    $('#check-b').on('change', (e: JQuery.ChangeEvent) => {
      checkboxBChecked = e.target.checked;

      checkCanSubmit();
    });

    btnAcceptDisclaimer.on('click', () => {
      closeDisclaimer();
    });
  };

  if (disclaimer.length && getCookie(cookieName) !== 'true') {
    showDisclaimer();
  }
};

function setCookie(cname: string, cvalue: string, milliseconds: number) {
  const d = new Date();
  d.setTime(d.getTime() + milliseconds);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires;
}

function getCookie(cname: string) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
